function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".cls-1,.primary{fill:none;}.white{fill:#fff;}.highlights-6{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "cls-1",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "white"
}, React.createElement("circle", {
  className: "white",
  cx: 124.61,
  cy: 132.61,
  r: 83.39
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("circle", {
  className: "highlights-6",
  cx: 128,
  cy: 128,
  r: 32
})), React.createElement("g", {
  id: "primary"
}, React.createElement("circle", {
  className: "primary",
  cx: 127.87,
  cy: 127.68,
  r: 88.13
}), React.createElement("line", {
  className: "primary",
  x1: 128,
  y1: 24,
  x2: 127.87,
  y2: 39.55
}), React.createElement("line", {
  className: "primary",
  x1: 128,
  y1: 216,
  x2: 127.87,
  y2: 231.55
}), React.createElement("line", {
  className: "primary",
  x1: 231.55,
  y1: 128,
  x2: 216,
  y2: 127.87
}), React.createElement("line", {
  className: "primary",
  x1: 39.55,
  y1: 128,
  x2: 24,
  y2: 127.87
})));
var SvgTarget = function SvgTarget(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTarget, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Target.20b79d1e.svg";
export { ForwardRef as ReactComponent };